/* tslint:disable */
/* eslint-disable */
/**
 * 輸送ロット調整API
 * 重量、パレット数、容量制約に基づいてアイテムを輸送ロットに割り当てるAPI
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TransportLotInputLotItemsInner } from './TransportLotInputLotItemsInner';
import {
    TransportLotInputLotItemsInnerFromJSON,
    TransportLotInputLotItemsInnerFromJSONTyped,
    TransportLotInputLotItemsInnerToJSON,
} from './TransportLotInputLotItemsInner';

/**
 * 
 * @export
 * @interface TransportLotInput
 */
export interface TransportLotInput {
    /**
     * 入荷日
     * @type {Date}
     * @memberof TransportLotInput
     */
    recDate: Date;
    /**
     * 輸送手段ID
     * @type {string}
     * @memberof TransportLotInput
     */
    transportTypeId: string;
    /**
     * 輸送番号　※XX台目
     * @type {string}
     * @memberof TransportLotInput
     */
    transportLotNo: string;
    /**
     * 車両の容量の上限（トン）
     * @type {number}
     * @memberof TransportLotInput
     */
    maxWeight: number;
    /**
     * パレット最大積載枚数
     * @type {number}
     * @memberof TransportLotInput
     */
    maxPalletCount: number;
    /**
     * 
     * @type {Array<TransportLotInputLotItemsInner>}
     * @memberof TransportLotInput
     */
    lotItems: Array<TransportLotInputLotItemsInner>;
}

/**
 * Check if a given object implements the TransportLotInput interface.
 */
export function instanceOfTransportLotInput(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "recDate" in value;
    isInstance = isInstance && "transportTypeId" in value;
    isInstance = isInstance && "transportLotNo" in value;
    isInstance = isInstance && "maxWeight" in value;
    isInstance = isInstance && "maxPalletCount" in value;
    isInstance = isInstance && "lotItems" in value;

    return isInstance;
}

export function TransportLotInputFromJSON(json: any): TransportLotInput {
    return TransportLotInputFromJSONTyped(json, false);
}

export function TransportLotInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransportLotInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'recDate': (new Date(json['rec_date'])),
        'transportTypeId': json['transport_type_id'],
        'transportLotNo': json['transport_lot_no'],
        'maxWeight': json['max_weight'],
        'maxPalletCount': json['max_pallet_count'],
        'lotItems': ((json['lot_items'] as Array<any>).map(TransportLotInputLotItemsInnerFromJSON)),
    };
}

export function TransportLotInputToJSON(value?: TransportLotInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'rec_date': (value.recDate.toISOString().substring(0,10)),
        'transport_type_id': value.transportTypeId,
        'transport_lot_no': value.transportLotNo,
        'max_weight': value.maxWeight,
        'max_pallet_count': value.maxPalletCount,
        'lot_items': ((value.lotItems as Array<any>).map(TransportLotInputLotItemsInnerToJSON)),
    };
}

